<script setup lang="ts">
import darkIcon from '@/assets/image/icons/vip-dark.webp'
import lightIcon from '@/assets/image/icons/vip-light.webp'
const props = defineProps({
  type: null,
  className: null,
  userSignType: null,
  domain: null
})
/**
 * 1、创作者，得到官方认证的，显示目前在用的金色认证：判断标准是持有运营空投的 NFT，获得认证；（就是我们入驻的 NFT）
 * 2、购买自己 share 的人，没有得到官方认证，显示银色认证，判断标准是购买了自己的 share；
 * 如果创作者购买了自己的Share，优先显示金色认证，两者不重叠显示；
 * userSignType: 0-普通用户；1-创作者；2-购买自己share的人
 */
const typeMap: any = ref({
  1: '!text-darkBrandYellow dark:!text-brandYellow',
})
const isDfans = computed(() => {
  return import.meta.env.VITE_APP_DFANS_DOMAIN === props?.domain
})
</script>

<template>
  <img
    v-if="isDfans"
    :src="isDark ? darkIcon : lightIcon"
    class="!w-20 shrink-0 ml-1"
    alt="dfans"
  />
  <div
    v-else-if="userSignType"
    i-icon-park-solid:success
    :class="`text-sm ml-1 cursor-pointer ${className} ${typeMap[userSignType]}`"
  />
</template>
